module.exports = __webpack_public_path__ + "img/the-beautique-hotels-figueira.ff1e5064.jpg";